<template lang="pug">
  BaseTable(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :table="table"
    :items="items"
    :meta="meta"
    :sort="sort"
    :page="page"
    :onDelete="onDelete"
    :toggleSort="toggleSort"
    :changePage="changePage"
  )
</template>

<script>
import BaseTable from '@/components/app/BaseTable'
import store from '@/store'
import { mapState, mapMutations } from 'vuex'

export default {
  components: { BaseTable },
  data: vm => ({
    title: vm.$t('fighters.categories.title')
  }),
  computed: {
    ...mapState('fightersCategories', ['routeKey', 'routes', 'table', 'items', 'meta', 'sort', 'page']),
    crumbs: vm => [
      { text: vm.$t('fighters.title'), to: { name: 'fighters.index' } },
      { text: vm.$t('fighters.categories.title') }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('fightersCategories/fetchItems')
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapMutations('fightersCategories', ['SET_SORT', 'SET_PAGE']),
    async onDelete (id) {
      await store.dispatch('fightersCategories/deleteItem', { id })
      await store.dispatch('fightersCategories/fetchItems')
      this.$notify({ message: this.$t('forms.notify.deleted') })
    },
    async toggleSort (field) {
      this.SET_SORT(field)
      await store.dispatch('fightersCategories/fetchItems')
    },
    async changePage (page) {
      this.SET_PAGE(page)
      await store.dispatch('fightersCategories/fetchItems')
    }
  }
}
</script>
